<template>
  <nuttrema-layout-popover-cred>
    <nav class="nav" slot="top">
      <div class="nav-center">
        <div class="nav-item nav-item--title">
          {{ $t(meta.title) }}
        </div>
      </div>
    </nav>
    <template slot="center-content">
      <template v-if="_get(StuffToEatImages, 'saveError')">
        <el-row type="flex" style="align-self: stretch">
          <el-col :span="24">
            <nuttrema-form-alert :error="_get(StuffToEatImages, 'saveError')" style="margin: 0.75em 1em 0 1em"></nuttrema-form-alert>
          </el-col>
        </el-row>
      </template>

      <el-upload
         class="cmpt-images-upload"
         action="action"
         ref="upload"
        :drag="true"
        :multiple="true"
        :auto-upload="false">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text" v-html="_markdown.renderInline($t('label.drop_file_here'))"></div>
          <div class="el-upload__tip" slot="tip">{{ $t('label.jpg_png_files') }}</div>
      </el-upload>
    </template>
    <template slot="bottom" v-if="!autoUpload">
      <nav class="nav">
        <div class="nav-left">
          <div class="nav-item">
            <el-button
               type="primary"
               size="small"
              :loading="StuffToEatImages.saving"
              @click="handleUploadImagesClick">
              {{ $t('label.start_upload') }}
            </el-button>
          </div>
        </div>
        <div class="nav-right">
          <div class="nav-item">
            <el-button size="small" type="text" @click="$emit('cancel')">{{ $t('label.cancel') }}</el-button>
          </div>
        </div>
      </nav>
    </template>
  </nuttrema-layout-popover-cred>
</template>

<script>
import { isEmpty, each } from 'lodash';

import SwitchSmall from 'components/ui/switch/switch-small';
import NuttremaFormAlert from 'components/ui/alert/nuttrema-form-alert';
import NuttremaLayoutPopoverCred from 'components/ui/layout/nuttrema-layout-popover-cred';

export default {
  name: 'cmpt-images-upload',
  props: {
    meta: {
      required: false,
      default: null,
    },
    StuffToEatImages: {
      required: false,
      default: null,
    },
  },
  components: {
    SwitchSmall,
    NuttremaFormAlert,
    NuttremaLayoutPopoverCred,
  },
  data() {
    return {
      autoUpload: false,
      files: [],
    };
  },
  methods: {
    handleUploadImagesClick() {
      const files = this.$refs.upload.uploadFiles;
      // console.log('handleUploadImagesClick', files);

      if (!isEmpty(files)) {
        const images = [];
        each(files, (file) => {
          images.push(file.raw);
        });
        this.$emit('uploadImage', images);
      }
    },
  },
};
</script>

<style lang="scss">
  .cmpt-images-upload {
    padding: 1em;
    width: 100%;
    .el-upload {
      width: 100%;
      .el-upload-dragger {
        border: none;
        width: inherit;
        height: 20em;
        .el-icon-upload {
          margin: 7rem 0 1rem;
        }
      }
    }
    .el-upload__tip {
      padding: 0 0.5em;
    }
  }
  .drop-area--auto-upload-label {
    span {
      font-size: 0.9rem;
      margin-right: 0.5em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/shared/images/cmpt-images-upload.vue